import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, PhoneIcon } from 'lucide-react';
export function SocialPromo() {
  return <section className="py-24 md:py-32 bg-ivory border-y border-brand-gold/20 relative overflow-hidden" data-id="element-418">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full pattern-dots opacity-20" data-id="element-419"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl -z-10" data-id="element-420"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-421">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-422">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-center md:text-left" data-id="element-423">
            <span className="text-brand-gold font-body text-sm uppercase tracking-[0.3em] font-bold mb-6 block" data-id="element-424">
              Connect With Us
            </span>
            <h2 className="font-display italic text-5xl md:text-6xl lg:text-7xl text-warm-brown mb-8 leading-tight" data-id="element-425">
              Let's create <br className="hidden md:block" data-id="element-426" />
              <span className="text-brand-gold" data-id="element-427">magic</span> together.
            </h2>
            <p className="text-lg text-near-black/70 font-body mb-10 max-w-md mx-auto md:mx-0" data-id="element-428">
              Follow us for daily inspiration, behind-the-scenes looks, and
              exclusive updates. Or call us directly to book your next
              appointment.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col gap-6" data-id="element-429">
            {/* Phone Promo */}
            <a href="tel:2409217857" className="group relative bg-cream p-8 rounded-3xl shadow-xl border border-brand-gold/20 flex items-center gap-6 overflow-hidden hover:-translate-y-2 transition-transform duration-300" data-id="element-430">
              <div className="absolute inset-0 bg-gradient-to-r from-brand-gold/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-431"></div>
              <div className="w-16 h-16 bg-warm-brown rounded-full flex items-center justify-center shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300" data-id="element-432">
                <PhoneIcon className="w-8 h-8 text-brand-gold" data-id="element-433" />
              </div>
              <div data-id="element-434">
                <span className="text-xs font-bold uppercase tracking-widest text-near-black/50 block mb-1" data-id="element-435">
                  Call Us Directly
                </span>
                <span className="font-display text-3xl md:text-4xl text-warm-brown group-hover:text-brand-gold transition-colors" data-id="element-436">
                  (240) 921-7857
                </span>
              </div>
            </a>

            {/* Instagram Promo */}
            <a href="https://www.instagram.com/roziiepse/" target="_blank" rel="noopener noreferrer" className="group relative bg-cream p-8 rounded-3xl shadow-xl border border-brand-gold/20 flex items-center gap-6 overflow-hidden hover:-translate-y-2 transition-transform duration-300" data-id="element-437">
              <div className="absolute inset-0 bg-gradient-to-r from-terracotta/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-438"></div>
              <div className="w-16 h-16 bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#F77737] rounded-full flex items-center justify-center shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300" data-id="element-439">
                <InstagramIcon className="w-8 h-8 text-cream" data-id="element-440" />
              </div>
              <div data-id="element-441">
                <span className="text-xs font-bold uppercase tracking-widest text-near-black/50 block mb-1" data-id="element-442">
                  Follow on Instagram
                </span>
                <span className="font-display text-3xl md:text-4xl text-warm-brown group-hover:text-terracotta transition-colors" data-id="element-443">
                  @roziiepse
                </span>
              </div>
            </a>

            {/* TikTok Promo */}
            <a href="https://www.tiktok.com/@roziiepse1.11" target="_blank" rel="noopener noreferrer" className="group relative bg-cream p-8 rounded-3xl shadow-xl border border-brand-gold/20 flex items-center gap-6 overflow-hidden hover:-translate-y-2 transition-transform duration-300" data-id="element-444">
              <div className="absolute inset-0 bg-gradient-to-r from-near-black/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-445"></div>
              <div className="w-16 h-16 bg-near-black rounded-full flex items-center justify-center shrink-0 shadow-lg group-hover:scale-110 transition-transform duration-300" data-id="element-446">
                <svg className="w-8 h-8 text-cream" viewBox="0 0 24 24" fill="currentColor" data-id="element-447">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.71a8.21 8.21 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.14z" data-id="element-448" />
                </svg>
              </div>
              <div data-id="element-449">
                <span className="text-xs font-bold uppercase tracking-widest text-near-black/50 block mb-1" data-id="element-450">
                  Follow on TikTok
                </span>
                <span className="font-display text-3xl md:text-4xl text-warm-brown group-hover:text-near-black transition-colors" data-id="element-451">
                  @roziiepse1.11
                </span>
              </div>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}